import YAutocomplete from './src/main'

YAutocomplete.install = function(Vue) {
  Vue.component(YAutocomplete.name, YAutocomplete)
}

export default YAutocomplete
